<app-common-header></app-common-header>
<main role="main" class="maincnt">
  <div class="getbannersect sectppad pb-2">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0 webview">
        <div class="col-12 text-center webview">
           <!-- <img src="assets/images/eva-icons.svg" class="signimg prescsimg" /> -->
          </div>
        <div class="col-sm-12 p-0 mt-5">
          <h1 class="text-center ssnHeadTxt">It looks like a deposit is required<br>
            to sign up for this plan</h1>
          <div class="col-lg-4 col-md-6 text-center m-auto">
            <span class="ssnTxt text-justify d-inline-block mt-3">In order to complete signing up for this plan, you
              are kindly being asked to post a deposit. To find out
              the deposit amount and for further details, please
              contact:
            </span>
            <div class="ssnenergyTxt text-center">
              <p class="fntbold mb-1">{{selectedProduct.energy_provider}}</p>
              <p class="mb-1">{{providerContact.working_hours}}</p>
              <p class="fntbold">{{providerContact.contact_number}}</p>
            </div>
            <span class="ssnTxt text-justify d-inline-block">
              Please be sure to mention Honest Gorilla and 
              {{selectedProduct.product_key}} when you speak with a {{providerContact.provider_name}} representative.
            </span>
            <div class="mt-3">
            <span class="ssnboxTxt backgrndclr text-justify d-inline-block">
              If you would like to explore a Pre-Paid electricity plan where no
              SSN, no credit check, and no deposit are required, then click
              below for more details. With Pre-Paid electricity, you just pay a
              small fee (which counts as your first pre-payment) and be eligible
              to receive power within the hour.
            </span>
          </div>
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center">
            <button class="btn pl-3 pr-3 font16 lnhgt15 minvalue mbnxt prepaidbtn fntregular mt-4" (click)="shop('prepaid')">Show me Pre-Paid options</button>
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center">
            <button class="btn shopBtn pl-3 pr-3 font16 lnhgt15 minvalue text-uppercase mbnxt semi-bold mt-4" (click)="shop('anotherProvider')">SHOP
              FOR ANOTHER PROVIDER</button>
          </div>
        </div>
      </div>
      <div class="container mobileview mt-0 pt-4">
          <div class="d-flex h-100 row col-sm-12 pr-0 mt-5">
              <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
                  <img style="width:100% !important;" src="assets/images/signimg.jpg" />
              </div>
              <div class="col-sm-9 col-9 px-0 my-auto">
                  <div class="arrow_box">
                      <h1 class="questionMob text-left">It looks like a deposit is required
                          to sign up for this plan</h1>
                  </div>
              </div>
          </div>    
          <div class="col-sm-9 col-12 ml-auto mt-4 pl-0">
              <p class="semi-bold ssndeptxt mb-1 text-center">Deposit Required</p>
              <p class="ssnTxt">In order to complete signing up for this plan, you
                are kindly being asked to post a deposit. To find out
                the deposit amount and for further details, please
                contact:
              </p>
              <div class="ssnenergyTxt text-center">
                <p class="fntbold mb-1">{{providerContact.provider_name}}</p>
                <p class="mb-1">{{providerContact.working_hours}}</p>
                <p class="fntbold">{{providerContact.contact_number}}</p>
              </div>
              <p class="ssnTxt">
                Please be sure to mention Honest Gorilla and {{selectedProduct.product_key}}
                when you speak with a {{providerContact.provider_name}} representative.
              </p>
            </div>
            <div class="d-flex h-100 row col-sm-12 pr-0 mt-4">
                <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
                    <img style="width:100% !important;" src="assets/images/signimg.jpg" />
                </div>
                <div class="col-sm-9 col-9 px-0 my-auto">
                    <div class="arrow_box">
                        <h1 class="questionMob text-left"> If you would like to explore a Pre-Paid electricity plan where no
                          SSN, no credit check, and no deposit are required, then click
                          below for more details. With Pre-Paid electricity, you just pay a
                          small fee (which counts as your first pre-payment) and be eligible
                          to receive power within the hour.</h1>
                    </div>
                </div>
            </div>   
            <div class="col-sm-9 col-9 ml-auto mt-4 px-0">
              <div class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center">
                  <button class="btn pl-3 pr-3 font16 lnhgt15 minvalue mbnxt prepaidbtn fntregular" (click)="shop('prepaid')">Show me Pre-Paid options</button>
                </div>
                <div class="col-lg-7 col-md-12 col-sm-12 p-0 shopmrgn pt-3 m-auto text-center">
                  <button class="btn shopBtn font16 lnhgt15 minvalue text-uppercase mbnxt semi-bold" (click)="shop('anotherProvider')">SHOP
                    FOR ANOTHER PROVIDER</button>
                </div>
            </div>
      </div>
    </div>
  </div>
</main>